import { signal } from "@preact/signals";
import { settings } from "./settings.js";

/**
 * The note after an hour (ADR 0043, P5-UX-07): play time adds up in this tab, match by match, and
 * once it passes an hour the next result says so, kindly, once. Off in the settings. Nothing is
 * sent anywhere.
 */
export const HOUR_MS = 60 * 60 * 1000;

const PLAYED = "obean.played";
const SHOWN = "obean.hourShown";

type Store = Pick<Storage, "getItem" | "setItem">;
const session = (): Store | null => {
  try {
    return typeof sessionStorage === "undefined" ? null : sessionStorage;
  } catch {
    return null;
  }
};

/** Play time in this tab so far (ms). */
export function played(store: Store | null = session()): number {
  try {
    const n = Number(store?.getItem(PLAYED) ?? 0);
    return Number.isFinite(n) && n > 0 ? n : 0;
  } catch {
    return 0;
  }
}

/** Whether the note is up now (a result shows it); set once the hour is passed. */
export const hourNote = signal(false);

/** A match's time, added when it ends or is left; it raises the note once past the hour. */
export function addPlayed(ms: number, store: Store | null = session()): void {
  if (!(ms > 0)) return;
  const total = played(store) + Math.min(ms, HOUR_MS); // a tab left open doesn't count as play
  try {
    store?.setItem(PLAYED, String(Math.round(total)));
  } catch {
    // No storage: this tab doesn't keep count.
  }
  if (total < HOUR_MS || !settings.peek().hourNote) return;
  try {
    if (store?.getItem(SHOWN) === "1") return;
    store?.setItem(SHOWN, "1");
  } catch {
    return; // without storage the note could come back every match: better none
  }
  hourNote.value = true;
}
